export const APP_RESOURCES = 'rs00-app/rs02-get-appresources';